import React from 'react';

export default function Style () {
    return (
        // eslint-disable-next-line react/no-unknown-property
        <style global jsx>
            { `
              html {
                font-size: 16px
              }
            ` }
        </style>
    );
};
